import { render, staticRenderFns } from "./code_list_detail.vue?vue&type=template&id=a0656bb2&scoped=true&"
import script from "./code_list_detail.vue?vue&type=script&lang=js&"
export * from "./code_list_detail.vue?vue&type=script&lang=js&"
import style0 from "./code_list_detail.vue?vue&type=style&index=0&id=a0656bb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0656bb2",
  null
  
)

export default component.exports